// @flow

import duplicateOrderCaveat from '../../../Services/duplicateOrderCaveat';
import type { DuplicateOrderCaveatParams } from '../../../types';

export default (params: DuplicateOrderCaveatParams) => async (dispatch: Function) => dispatch(duplicateOrderCaveat(params))